// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` table {
   width: 50%;
   border-collapse: collapse;
   margin-bottom: 20px;
 }

 .bookingSect th,
 td {
   border: 1px solid #ddd;
   padding: 8px;
 }

 .bookingSect th {
   background-color: #f2f2f2;
   text-align: left;
 }

 .bookingSect tr:hover {
   background-color: #f5f5f5;
 }

 .bookingSect .table td,
 .table th {
   width: 70px;
 }

 .bookingSect .small {
   font-size: 12px;
 }`, "",{"version":3,"sources":["webpack://./src/css/Booking.css"],"names":[],"mappings":"CAAC;GACE,UAAU;GACV,yBAAyB;GACzB,mBAAmB;CACrB;;CAEA;;GAEE,sBAAsB;GACtB,YAAY;CACd;;CAEA;GACE,yBAAyB;GACzB,gBAAgB;CAClB;;CAEA;GACE,yBAAyB;CAC3B;;CAEA;;GAEE,WAAW;CACb;;CAEA;GACE,eAAe;CACjB","sourcesContent":[" table {\n   width: 50%;\n   border-collapse: collapse;\n   margin-bottom: 20px;\n }\n\n .bookingSect th,\n td {\n   border: 1px solid #ddd;\n   padding: 8px;\n }\n\n .bookingSect th {\n   background-color: #f2f2f2;\n   text-align: left;\n }\n\n .bookingSect tr:hover {\n   background-color: #f5f5f5;\n }\n\n .bookingSect .table td,\n .table th {\n   width: 70px;\n }\n\n .bookingSect .small {\n   font-size: 12px;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
